import { Container } from "@/shared/components/Container";
import { SectionTag } from "@/shared/components/SectionTag";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { Reveal } from "@/shared/components/Reveal";
import { useInView } from "@/shared/hooks/useInView";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Approach.module.css";

export function Approach() {
  const locale = useLocale();
  const content = getHomeContent(locale);

  const { ref: diagramRef, inView: diagramInView } = useInView<HTMLDivElement>({
    enterEdgeRatio: 0.1,
    once: true,
  });

  return (
    <section id="abordagem" className={styles.approach}>
      <Container>
        <Reveal className={styles.header}>
          <SectionTag>{content.approach.tag}</SectionTag>
          <GradientHeading className={styles.title}>
            {content.approach.title}
          </GradientHeading>
          <p className={styles.subtitle}>
            {content.approach.subtitle}
          </p>
        </Reveal>

        <Reveal className={styles.stage} delay={120}>
          <div className={styles.side}>
            <h3 className={`${styles.sideHeading} ${styles.sideHeadingBlue}`}>
              {content.approach.consultingHeading}
            </h3>
            <p className={`${styles.sideText} ${styles.sideTextBlue}`}>
              {content.approach.consultingText}
            </p>
          </div>

          <div
            ref={diagramRef}
            className={`${styles.diagram} ${diagramInView ? styles.diagramIn : ""}`}
          >
            <div className={styles.core}>
              <span className={styles.coreText}>{content.approach.coreText}</span>
            </div>
            {/* Anéis tracejados exatos do Figma (SVG = traço uniforme e crisp):
                externo 560 (op. 0.1), médio 440 (op. 0.2) e o do core 320 (op. 0.8,
                o mais visível). Fica sobre o core p/ o anel de 320 desenhar na borda. */}
            <svg
              className={styles.rings}
              viewBox="0 0 560 560"
              fill="none"
              aria-hidden
            >
              <circle
                cx="280"
                cy="280"
                r="279.5"
                stroke="#02578A"
                strokeOpacity="0.1"
                strokeWidth="1.5"
                strokeDasharray="14 10"
              />
              <circle
                cx="280"
                cy="280"
                r="219.5"
                stroke="#02578A"
                strokeOpacity="0.2"
                strokeWidth="1.5"
                strokeDasharray="14 10"
              />
              <circle
                cx="280"
                cy="280"
                r="159.5"
                stroke="#02578A"
                strokeOpacity="0.8"
                strokeWidth="1.5"
                strokeDasharray="14 10"
              />
            </svg>
            <span className={`${styles.badge} ${styles.badgeTop}`}>{content.approach.badgePeople}</span>
            <span className={`${styles.badge} ${styles.badgeBottomLeft}`}>{content.approach.badgeProcesses}</span>
            <span className={`${styles.badge} ${styles.badgeBottomRight}`}>{content.approach.badgeSystems}</span>
          </div>

          <div className={styles.side}>
            <h3 className={`${styles.sideHeading} ${styles.sideHeadingAmber}`}>
              {content.approach.technologyHeading}
            </h3>
            <p className={`${styles.sideText} ${styles.sideTextAmber}`}>
              {content.approach.technologyText}
            </p>
          </div>
        </Reveal>

        <Reveal as="p" className={styles.footnote} delay={200}>
          {content.approach.footnote}
        </Reveal>
      </Container>
    </section>
  );
}
